import React from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';

const ShipmentSuccess: React.FC = () => {
    return (
        <div style={styles.container}>
            <CheckCircleOutlined style={styles.icon} />
            <p style={styles.text}>Les supports et emballages ont été validés avec succès !</p>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f9f9f9',
    },
    icon: {
        fontSize: '3rem',
        color: '#28a745',
    },
    text: {
        marginTop: '1rem',
        fontSize: '1.25rem',
        textAlign: 'center' as const,
        color: 'rgb(40, 167, 69)',
    },
};

export default ShipmentSuccess;
